module.exports = __webpack_public_path__ + "img/monster-mayhem.45c1665e.png";